<template>
  <div class="rc-subscriber-verify">
    <form @submit.stop.prevent class="rc-subscriber-verify--form">
      <div class="row g-0 mb-3">
        <label
          for="rcSelectProvince"
          class="col-form-label"
          :class="'col-md-' + labelCols"
          >Province</label
        >
        <div class="col">
          <select
            v-model="selectedProvince"
            id="rcSelectProvince"
            class="form-select form-select"
          >
            <option
              v-for="(province, index) in provinces"
              :value="province.value"
              :key="index"
            >
              {{ province.text }}
            </option>
          </select>
        </div>
      </div>

      <div class="row g-0 mb-2 rc-subscriber-combobox">
        <label
          :for="inputProps.id"
          class="col-form-label pt-1"
          :class="'col-md-' + labelCols"
          >{{ $t(`common.institution_name`) }}</label
        >
        <div class="col">
          <div class="rc-combobox-container">
            <RcComboBox
              v-bind="inputProps"
              :apiListOptions="listApiOptions"
              @selected="selectedOrg = $event"
              size="lg"
            >
              <template #option="{ opt }">
                <div>
                  <div>{{ opt.name }}</div>
                  <span class="text-body-secondary">{{ opt.city }}</span>
                </div>
              </template>
            </RcComboBox>
          </div>

          <div
            v-if="validateState == false"
            id="feedback_invalid__subscriber"
            aria-live="assertive"
            aria-atomic="true"
            class="invalid-feedback d-block"
          >
            <div class="mb-3">
              {{ $t("auth.school.not_found_by_name") }}
              <a :href="$t('nav.url.help_school_not_found')">{{
                $t("common.find_out_more")
              }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-0">
        <div
          :class="
            labelCols == 12 ? 'col-md-12' : 'col-md-8 offset-md-4 ps-md-1'
          "
        >
          <RcDebounced
            block
            variant="primary"
            size="lg"
            :promise="onContinue"
            class="mx-auto"
            >{{ $t("common.continue") }}
          </RcDebounced>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { SET_SUBSCRIBER } from "@/libvue/apps/subscribers/actions";

import RcComboBox from "@/libvue/components/select/comboBox.vue";
import RcDebounced from "@/libvue/components/button/DebouncedButton.vue";

export default {
  name: "RcSubscriberVerify",
  components: {
    RcComboBox,
    RcDebounced
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedOrg: {},
      comp: "RcSubscriberVerify",
      selectedProvince: null
    };
  },
  props: {
    labelCols: {
      type: Number,
      default: 12
    }
  },
  validations: {
    selectedOrg: { required }
  },
  mounted() {
    this.selectedProvince = this.region;
  },
  computed: {
    lat() {
      return window.geoip_latitude();
    },
    lon() {
      return window.geoip_longitude();
    },
    region() {
      return window.geoip_region();
    },
    validateState() {
      const { $dirty, $error } = this.v$.selectedOrg;
      return $dirty ? !$error : null;
    },
    provinces() {
      return [
        { text: this.$t("province.AB"), value: "AB" },
        { text: this.$t("province.BC"), value: "BC" },
        { text: this.$t("province.MB"), value: "MB" },
        { text: this.$t("province.NB"), value: "NB" },
        { text: this.$t("province.NL"), value: "NL" },
        { text: this.$t("province.NS"), value: "NS" },
        { text: this.$t("province.NT"), value: "NT" },
        { text: this.$t("province.NU"), value: "NU" },
        { text: this.$t("province.ON"), value: "ON" },
        { text: this.$t("province.PE"), value: "PE" },
        { text: this.$t("province.QC"), value: "QC" },
        { text: this.$t("province.SK"), value: "SK" },
        { text: this.$t("province.YT"), value: "YT" }
      ];
    },
    routeName() {
      return this.$route.name;
    },
    listApiOptions() {
      return {
        url: `subscribers`,
        method: "get",
        authRequired: false,
        params: {
          state: this.selectedProvince
        }
      };
    },
    inputProps() {
      return {
        id: "rc-combobox__subscriber",
        class: this.validateState != false ? "" : "is-invalid",
        "aria-invalid": this.validateState != false ? null : true,
        "aria-describedby":
          this.validateState != false ? null : "feedback_invalid__subscriber"
      };
    }
  },
  methods: {
    onContinue() {
      if (this.selectedOrg) {
        this.$store.commit(SET_SUBSCRIBER, this.selectedOrg);
        this.$router.push({
          name: "auth.login",
          params: { locale: this.$i18n.locale }
        });
      } else {
        this.v$.$touch();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
